import React from 'react';

/**
 * Shows a spinner while a tool is executing, then a checkmark when complete.
 */
export default function ChatToolIndicator({ toolName, completed }) {
    return (
        <div className={`chat-tool-indicator ${completed ? 'completed' : ''}`}>
            {!completed && <div className="chat-tool-indicator-spinner" />}
            <span>{completed ? `Completed: ${formatToolName(toolName)}` : `Working: ${formatToolName(toolName)}…`}</span>
        </div>
    );
}

/**
 * Convert snake_case tool name to human-readable label.
 */
function formatToolName(name) {
    const labels = {
        search_prescribers: 'Searching prescribers',
        get_prescriber: 'Fetching prescriber details',
        get_prescribers_by_territory: 'Fetching territory prescribers',
        get_aligned_messages: 'Fetching aligned messages',
        get_prescriber_top_plans: 'Fetching prescriber plans',
        get_markets: 'Fetching markets',
        get_quick_sheets: 'Fetching quick sheets',
        get_sell_sheet_dashboard: 'Fetching sell sheet dashboard',
        get_analytics_logins: 'Fetching analytics',
        get_analytics_generations: 'Fetching generation analytics',
        get_leaderboard: 'Fetching leaderboard',
        get_current_user: 'Fetching user info',
        generate_sell_sheet: 'Generating sell sheet',
        generate_sell_sheet_smart: 'Generating sell sheet',
        send_to_print_queue: 'Sending to print queue',
        toggle_favorite_hcp: 'Toggling favorite',
    };
    return labels[name] || name?.replace(/_/g, ' ') || 'Processing';
}
